import { CompanyBody, GetPlanAction } from "@vviinn/user-managment-client-ts";
import { Company as TCompany } from "@vviinn/user-managment-client-ts/dist/models/Company";

import { capitalize } from "../../../helpers/string/capitalize";
import {
  addCompanyToState,
  fetchCompanies,
  removeCompanyFromState,
} from "../companies/companies-slice";
import {
  deleteCompany,
  getCompany,
  getCompanyAllPlans,
  updateCompany,
} from "./company-slice";
import { responseNotification } from "../../../components/Notifications";
import { fetchUsers } from "../users/users-slice";

import { RequestHandlerParams } from "..";

type UpdateCompanyFieldProps = keyof Pick<CompanyBody, "name">;

export const handleCompany = (params: RequestHandlerParams) => {
  const { getApi, notify, dispatch } = params;
  return {
    async fetchCompany(id: TCompany["id"]) {
      const api = await getApi();
      dispatch(getCompany({ api, value: id }));
    },

    async handleUpdateCompanyField(
      field: UpdateCompanyFieldProps,
      id: TCompany["id"],
      value: string,
    ) {
      const api = await getApi();
      notify("Info", `Updating company ${field}`);

      const result = await dispatch(
        updateCompany({
          api,
          value: {
            id,
            [field]: value,
          },
        }),
      );
      const isSuccess = !!result.payload;
      if (isSuccess) {
        const api = await getApi();
        dispatch(fetchCompanies(api));
      }
      return responseNotification(notify, isSuccess, {
        successMessage: `${capitalize(field)} updated`,
        errorMessage: `Error when updating ${field}`,
      });
    },

    async handleDeleteCompany(id: TCompany["id"]) {
      const api = await getApi();
      const response = await dispatch(deleteCompany({ api, value: id }));
      if (response.payload) {
        dispatch(removeCompanyFromState(response.payload));
      }
      return !!response.payload;
    },

    async handleLoadAllPlans(companyId: TCompany["id"], action: GetPlanAction) {
      const api = await getApi();
      const details = await dispatch(
        getCompanyAllPlans({ api, value: { companyId, action } }),
      );
      return details.payload;
    },

    async handleCreateNewCompany(body: CompanyBody) {
      const api = await getApi();
      const response = await dispatch(updateCompany({ api, value: body }));
      const companyUpdate = response.payload;
      if (response.meta.requestStatus === "fulfilled") {
        dispatch(addCompanyToState(companyUpdate));
        dispatch(fetchUsers(api));
        const companyCredentials = companyUpdate as CompanyBody;
        return companyCredentials?.id;
      }
    },
  };
};
